<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>Informazioni sulla vendita</h1>

<div mat-dialog-content>
    <section id="schedaConsegna" class="content-padding" *ngIf="delivery">
        <div class="narrow-wrapper">
            <div class="delivery-colle-data-box">
                <fieldset>
                    <legend>Dettagli della vendita:</legend>
    
                    <div class="col-50 grid-element field">
                        <h3>Stato</h3>
                        <p id="outpuStato" >Da gestire</p>
                    </div>
    
                    <div class="col-50 grid-element field">
                        <h3>Data consegna</h3>
                        <p>{{(delivery.actualDate || delivery.deliveryDate) | date:"dd/MM/yyyy" || "---"}}</p>
                    </div>
    
                    <div class="col-50 grid-element field">
                        <h3>Fascia oraria Consegna</h3>
                        <p>
                          {{(delivery.fromTime) ? (delivery.fromTime | time: 'HH:mm') : "---"}} - {{(delivery.toTime) ? (delivery.toTime | time: 'HH:mm') : "---"}}
                        </p>
                    </div>
    
                    <div class="col-50 grid-element field">
                        <h3>Fascia Orario Ritiro</h3>
                        <p id="outputExpert">{{ delivery?.pickUpTime || "---" }}</p>
                    </div>
    
                    <div class="col-100 grid-element field">
                        <div class="flex_wrap"> 
                            <h3 style="margin-bottom: 16px;">Prodotto </h3>
                            <h3 style="margin-bottom: 16px;">Descritzione</h3>
                        </div>
                        <div style="display: flex; justify-content: space-between; " class="prodTable" *ngFor="let dProduct of delivery.deliveryProducts">
                            <div style="width: 250px; cursor: pointer;" (click)="showImage(dProduct)">{{dProduct.product?.name}} </div>
                            <div style="width: 250px;">{{ dProduct.product?.description || "---" }}</div>
                        </div>
                    </div>
    
                    <div class="col-50 grid-element field">
                        <h3 style="margin-bottom: 16px;">Prodotto Image</h3>
                        <div *ngFor="let dProduct of delivery.deliveryProducts">
                            <img class="product-image" *ngIf="dProduct?.product?.image" [src]="dProduct?.product?.image" alt="" (click)="openImage(dProduct?.product?.image)" style="cursor: pointer;">
                            <img class="product-image" *ngIf="dProduct?.product?.image === null || dProduct?.product?.image === undefined " src="./assets/img/no-image.jpg" alt="" (click)="openImage('./assets/img/no-image.jpg')">
                        </div>
                    </div>
    
                    <div class="col-50 grid-element field">
                        <h3>Prezzo</h3>
                        <p id="outputNoteConsegna" style="white-space: pre-wrap;">{{totalProductPrice}}€</p>
                    </div>

                    <div class="col-50 grid-element field">
                        <h3 style="margin-bottom: 16px;">Variant</h3>
                        <div class="dlx-value" *ngFor="let dProduct of delivery.deliveryProducts">
                            <span *ngIf="dProduct?.product?.productOptionTitle">
                            <b>({{ dProduct?.product?.productOptionTitle }})</b>
                            </span> 
                            {{ dProduct?.productVariant?.variantName || "---" }}
                        </div>
                    </div>
    
                    <div class="col-50 grid-element field">
                        <h3 style="margin-bottom: 16px;">Variant Price</h3>
                        <div class="dlx-value" *ngFor="let dProduct of delivery.deliveryProducts">
                            <span *ngIf="dProduct?.product?.productOptionTitle">
                            <b>({{ dProduct?.product?.productOptionTitle }})</b>
                            </span> 
                            {{ dProduct?.productVariant?.variantPrice || "---" }}
                        </div>
                    </div>
    
                    <div class="grid-element-full field">
                        <h3>Note</h3>
                        <p id="outputNoteConsegna" style="white-space: pre-wrap;">{{delivery.notes || "---"}}</p>
                    </div>
                    <!--
                    <div class="grid-element-full field center">
                        <button type="button" class="btn hvr-shrink center" [disabled]="disableProposeSaleBtn || disablebtn" (click)="acceptSale()">Accetta Vendita</button>
                    </div>
                    <div class="grid-element-full field center">
                        <button type="button" class="btn hvr-shrink center" [disabled]="disableProposeSaleBtn || disablebtn" (click)="refuseSale()">Rifiuta Vendita</button>
                    </div>
                    -->
                </fieldset>
            </div>
        </div>
    </section>
</div>

<div mat-dialog-actions>
    <div>
        <button mat-button mat-dialog-close class="btn">Chiudi</button>
    </div>
</div>
